import queryString from 'query-string';

import type {
  IanaTimezoneString,
  ApiISODateTimeNoTzString,
  ApiISODateTimeString,
} from '#/api/types/ApiTypedDate';

import { getJson } from './http/getJson';

export function getUserTimezone(): IanaTimezoneString {
  if (!Intl?.DateTimeFormat) {
    const offsetMinutes = new Date().getTimezoneOffset();
    const offsetHours = -offsetMinutes / 60;
    return `UTC${offsetHours >= 0 ? '+' : ''}${offsetHours}`;
  }

  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export async function getTimezoneFromLatLng(
  lat: number,
  lng: number,
): Promise<string> {
  return getJson<{
    utc: ApiISODateTimeString;
    atPosition: ApiISODateTimeNoTzString;
    timezone: IanaTimezoneString;
  }>(
    queryString.stringifyUrl({
      url: '/data/time/at-position',
      query: { lat, lng },
    }),
  ).then(({ timezone }) => timezone);
}
